export interface Review {
  // #2199 書いた人の ID (メールアドレスのハッシュ) は公開の店の情報に載せない
  userName?: string
  rating: number
  tags: string[]
  comment: string
  nationality: string
  createdAt: string
}

export const ALLERGEN_INFO: Record<string, { emoji: string; label: string }> = {
  egg: { emoji: '🥚', label: 'allergen.egg' },
  milk: { emoji: '🥛', label: 'allergen.milk' },
  wheat: { emoji: '🌾', label: 'allergen.wheat' },
  soy: { emoji: '🫘', label: 'allergen.soy' },
  fish: { emoji: '🐟', label: 'allergen.fish' },
  shrimp: { emoji: '🦐', label: 'allergen.shrimp' },
  crab: { emoji: '🦀', label: 'allergen.crab' },
  peanut: { emoji: '🥜', label: 'allergen.peanut' },
  soba: { emoji: '🍜', label: 'allergen.soba' },
}

export const DIETARY_INFO: Record<string, { emoji: string; label: string; color: string }> = {
  halal: { emoji: '☪️', label: 'dietary.halal', color: 'bg-emerald-100 text-emerald-700' },
  vegetarian: { emoji: '🥬', label: 'dietary.vegetarian', color: 'bg-green-100 text-green-700' },
  vegan: { emoji: '🌱', label: 'dietary.vegan', color: 'bg-lime-100 text-lime-700' },
  'pork-free': { emoji: '🚫🐷', label: 'dietary.porkFree', color: 'bg-orange-100 text-orange-700' },
  'alcohol-free': { emoji: '🚫🍺', label: 'dietary.alcoholFree', color: 'bg-blue-100 text-blue-700' },
}

export const categoryGradients: Record<string, string> = {
  restaurant: 'from-navy via-navy-light to-amber-900/40',
  cafe: 'from-amber-800 via-amber-700 to-yellow-600',
  izakaya: 'from-red-900 via-orange-800 to-yellow-700',
  bar: 'from-slate-900 via-slate-700 to-slate-600',
  ramen: 'from-orange-900 via-amber-800 to-yellow-700',
  sushi: 'from-blue-900 via-teal-800 to-cyan-700',
  bakery: 'from-amber-700 via-orange-600 to-yellow-500',
  sweets: 'from-pink-700 via-rose-600 to-fuchsia-500',
  kitchencar: 'from-emerald-800 via-teal-700 to-cyan-600',
  shop: 'from-rose-800 via-pink-700 to-fuchsia-600',
  hotel: 'from-indigo-900 via-blue-800 to-sky-700',
  other: 'from-gray-700 via-gray-600 to-gray-500',
  // #1661 業態キー（飲食以外は category を持たないので genre で引く）
  food: 'from-navy via-navy-light to-amber-900/40',
  souvenir: 'from-rose-800 via-pink-700 to-fuchsia-600',
  experience: 'from-emerald-900 via-green-700 to-lime-600',
}

export const MENU_CATEGORIES: { key: string; label: string }[] = [
  { key: 'all', label: 'category.all' },
  { key: 'main', label: 'category.main' },
  { key: 'side', label: 'category.side' },
  { key: 'appetizer', label: 'category.appetizer' },
  { key: 'drink-soft', label: 'category.drinkSoft' },
  { key: 'drink-alcohol', label: 'category.drinkAlcohol' },
  { key: 'dessert', label: 'category.dessert' },
]
